import { observable } from 'mobx'
import { asNumber } from '@taxfyle/web-commons/lib/utils/numberUtil'

export default class TxfConfigViewModel {
  @observable
  txfStripeCustomerId = undefined

  @observable
  autoVerificationConfig = 'SKIP_WHEN_POSSIBLE'

  @observable
  totalCredits = undefined

  activate(
    txfStripeCustomerId = undefined,
    autoVerificationConfig = 'SKIP_WHEN_POSSIBLE',
    totalCredits = undefined
  ) {
    this.txfStripeCustomerId = txfStripeCustomerId
    this.autoVerificationConfig = autoVerificationConfig
    this.totalCredits = totalCredits
  }

  toJSON() {
    return {
      stripe_customer_id: this.txfStripeCustomerId,
      auto_verification_config: this.autoVerificationConfig,
      total_credits: asNumber(this.totalCredits),
    }
  }
}
